<template>
    <div class="container">
        <textarea v-model="internalText" :class="['fixedHeight', 'form-control', 'rounded-0', 'col-12', {'border-danger': errorStyle}]" :rows="rows" readonly="true"></textarea>
        <span v-if="alternateText" class="d-flex justify-content-center alternate-text">{{alternateText}}</span>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueClipboard from 'vue-clipboard2';    
    Vue.use(VueClipboard);

    export default {
        props: {
            lines: {
                type: Array,
                default: []            
            },
            text: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: "Clipboard"
            },
            errorStyle: {
                type: Boolean,
                default: false
            },
            buttons: {
                type: Array,
                default: () => [{
                    name: "$Close"
                }]
            },
            buttonsCustom: {
                type: Array,
                default: () => [{
                    name: "Copy to Clipboard",
                    onClick: this.copyToClipboard
                }]
            },
            alternateText: {
                type: String,
                default: null
            }
        },
        computed: {
            rows() {
                return this.lines.length < 10 ? 10 : this.lines.length;
            },
            internalText() {
                return this.lines.join('\n') || this.text
            }
        },
        methods: {
            copyToClipboard(){
                this.$copyText(this.internalText).then(function(e) {
                    toastService.success(`Copied text to clipboard.`);
                    console.log(e.text);
                }, function (e) {
                    toastService.error("Error copying text to clipboard.  It could be a browser incompatibility issue.  Try copying with ctrl + c.")
                });
            }
        },        
    }
</script>

<style lang="scss" scoped>
    .fixedHeight {
        overflow-y: scroll;
        max-height: 375px; 
    }

    .alternate-text {
        padding: 10px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/framework/primitives/MultiLineInfoModal.vue